import {
  Box,
  Card,
  Grid,
  IconButton,
  Tooltip,
  Typography,
  Stack,
} from "@mui/material";
import React, { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import {
  RiErrorWarningLine,
  RiShieldStarLine,
  RiVerifiedBadgeFill,
} from "react-icons/ri";
import PropTypes from "prop-types";
import "./ClinicianSpecialtiesCss.css";
import "./CardOverlay.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedTabData } from "../../../slice/profileTabSectionSlice";
import { AiFillStar } from "react-icons/ai";
import AssessmentRating from "./AssessmentRating";
import ChecklistModal from "./ChecklistModal";
import AssessmentModal from "./AssessmentModal";

const ClinicianSpecialties = ({ data }) => {
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedSpecialtyId, setSelectedSpecialtyId] = useState(null);
  const [assessmentModalOpen, setAssessmentModalOpen] = useState(false);
  const [selectedAssessmentSpecialtyId, setSelectedAssessmentSpecialtyId] =
    useState(null);

  console.log("data343", data);
  const dispatch = useDispatch();
  const location = useLocation();
  const { controlBy, controlAction, controlUser } = useSelector(
    (state) => state.user,
  );
  console.log(":controlUser", controlUser);

  const AllViewControl =
    controlAction === "view" &&
    (controlBy === "facility" || controlBy === "admin");
  const AdminEditControl = controlAction === "edit" && controlBy === "admin";

  const addNewSpecialty = () => {
    if (AdminEditControl) {
      navigate("/admin/clinician-users/edit-specialty");
    } else {
      navigate("/clinician/profile/add-specialties");
    }
  };

  const handleClickedSpecialty = (specialty) => {
    console.log("controlBy", controlBy);
    if (controlBy === "facility") {
      console.log("first", specialty);
      navigate(
        `/facility/clinican-users/:ID/assess-specialities/${specialty.SPECIALTY_ID}/`,
      );
      return;
    }
    dispatch(
      setSelectedTabData({
        ASSEMENT_CHECK: specialty.ASSEMENT_CHECK,
        CHECKLIST_CHECK: specialty.CHECKLIST_CHECK,
      }),
    );
    console.log(
      "specialityID",
      specialty?.SPECIALTY_ID,
      AllViewControl,
      AdminEditControl,
    );
    if (AllViewControl || AdminEditControl) {
      navigate(
        `/${controlBy}/profile/assess-specialities/${specialty?.SPECIALTY_ID}`,
      );
    } else {
      navigate(
        `/clinician/profile/assess-specialities/${specialty?.SPECIALTY_ID}`,
      );
    }
  };

  const handleChecklistClick = (e, specialty) => {
    e.preventDefault();
    e.stopPropagation();
    setSelectedSpecialtyId(specialty.SPECIALTY_ID);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedSpecialtyId(null);
  };

  const handleAssessmentClick = (e, specialty) => {
    e.preventDefault();
    e.stopPropagation();
    setSelectedAssessmentSpecialtyId(specialty.SPECIALTY_ID);
    setAssessmentModalOpen(true);
  };

  const handleCloseAssessmentModal = () => {
    setAssessmentModalOpen(false);
    setSelectedAssessmentSpecialtyId(null);
  };
  console.log("data", data);
  return (
    <Card sx={{ padding: "20px", marginTop: 2 }}>
      <Grid container alignItems="center">
        <Grid item xs={12} sm={6}>
          <Typography variant="h3" className="about_text_black">
            Specialties
          </Typography>
          <Typography variant="body1" className="desc-text" mt={1}>
            Assessing Your proficiency and skills to enhance professional
            development.
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6} display="flex" justifyContent={"flex-end"}>
          {/* {NoAccess && */}
          {!AllViewControl && (
            <Box display="flex" alignItems="center" onClick={addNewSpecialty}>
              <AddIcon
                sx={{ color: "#6ebe44", cursor: "pointer" }}
                fontSize="large"
              />
            </Box>
          )}
        </Grid>
      </Grid>

      <Grid container spacing={3} sx={{ justifyContent: "flex-start" }}>
        {data &&
          data?.map(
            (specialty, index) => (
              console.log("specialty", specialty.ASSEMENT_CHECK),
              (
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <Card
                    onClick={() => handleClickedSpecialty(specialty)}
                    sx={{
                      padding: 2,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      height: 150, // Fixed square height
                      textAlign: "left", // Align text to left
                      position: "relative", // Allows positioning of warning icon
                      backgroundColor: "#f5f5f5",
                      borderRadius: "4px",
                      cursor: controlBy === "facility" ? "" : "pointer",

                      transition: "background-color 0.3s ease",
                      "&:hover": { backgroundColor: "#e0e0e0" },
                    }}
                    className="card-container"
                  >
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      {/* Alarm Icon at the Top Center */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor: "white",
                          borderRadius: "50%",
                          width: { xs: 30, sm: 40, md: 40 },
                          height: { xs: 30, sm: 40, md: 40 },
                          boxShadow: 1,
                        }}
                      >
                        <RiShieldStarLine
                          style={{ fontSize: { xs: 16, sm: 18, md: 20 } }}
                        />
                      </Box>
                      <Stack direction="row" alignItems="center" spacing={1}>
                        <AssessmentRating score={specialty.SCORE} />
                      </Stack>
                    </Box>

                    {/* Dynamic Text */}
                    <Typography
                      variant="body2"
                      sx={{
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {specialty.SPECIALTY_NAME}
                    </Typography>

                    <Typography variant="body2" className="checklist">
                      {specialty?.CHECKLIST_CHECK ? (
                        <>
                          Checklist{" "}
                          <RiVerifiedBadgeFill style={{ color: "green" }} />{" "}
                          <a
                            href="#"
                            onClick={(e) => handleChecklistClick(e, specialty)}
                          >
                            Checklist
                          </a>
                        </>
                      ) : (
                        <>
                          Checklist <RiErrorWarningLine color="#EA4933" />
                        </>
                      )}
                    </Typography>

                    <Typography variant="body2" className="evaluation">
                      {specialty?.ASSEMENT_CHECK ? (
                        <>
                          Assessment{" "}
                          <RiVerifiedBadgeFill style={{ color: "green" }} />{" "}
                          <a
                            href="#"
                            onClick={(e) => handleAssessmentClick(e, specialty)}
                          >
                            Assessment
                          </a>
                        </>
                      ) : (
                        <>
                          Assessment <RiErrorWarningLine color="#EA4933" />
                        </>
                      )}
                    </Typography>
                  </Card>
                </Grid>
              )
            ),
          )}
      </Grid>
      {selectedSpecialtyId && (
        <ChecklistModal
          open={modalOpen}
          handleClose={handleCloseModal}
          specialityID={selectedSpecialtyId}
        />
      )}

      {selectedAssessmentSpecialtyId && (
        <AssessmentModal
          open={assessmentModalOpen}
          handleClose={handleCloseAssessmentModal}
          specialityID={selectedAssessmentSpecialtyId}
        />
      )}
    </Card>
  );
};
ClinicianSpecialties.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      ID: PropTypes.string.isRequired,
      SPECIALTY_NAME: PropTypes.string.isRequired,
    }),
  ).isRequired,
};
export default ClinicianSpecialties;
